import {
    ADD_TO_CART, MINUS_TO_CART, CHANGEPOPSTATUS, SETSERVERCART, SET_MULTI_ORDER_POPUP_SHOWN, SET_VOUCHER_CODE,
    SETCARTERROR, SETPAYMENT, ORDERSUCESS, ORDERREDIRECT, FINALCARTRESPONSE, FINALSETTLE, REDIRECTORDER, SETORDERINSTRUCTIONS,
    SETVOUCHERSUCCESS, SETFINALCARTERROR, REMOVETABLE
} from "../actionTypes";
import axios from './axios';
import throttle from 'lodash.throttle';
import moment from 'moment';



export const addToCart = (item, size_id, addons, qty, price, order_notes = "") => (dispatch, getState) => {
    const state = getState();
    let { items } = state.cart;

    if (!item.addon_item_exists) {
        if (items.some(cartItem => cartItem.item_id == item.item_id)) {
            items = items.map(cartItem => {
                if (cartItem.item_id == item.item_id) {
                    cartItem.qty++;
                    cartItem.sub_item.forEach(subItem => {
                        subItem.qty++;
                    })
                }
                return cartItem;
            })
            localStorage.setItem("cart", items);
            dispatch({
                type: ADD_TO_CART,
                payload: items
            })
            return;
        }
    }
    const tmpItems = [...items];
    let subTotal = price;
    addons.forEach(element => {
        subTotal = subTotal + +element.price;
        element.value = element.sub_item_id + "|0";
        element.qty = qty;
    });
    const cartItem = {};
    cartItem.item_id = item.item_id;
    cartItem.name = item.item_name;
    cartItem.size_id = size_id;
    cartItem.size_name = size_id ? item.prices.find(price => price.size_id == size_id).size : "";
    cartItem.price = price + "|" + size_id;
    cartItem.unitPrice = price;
    cartItem.sub_item = addons;
    cartItem.qty = qty;
    cartItem.subtotal = price * qty;
    cartItem.dish = item.dish_new;
    cartItem.order_notes = order_notes;
    tmpItems.push(cartItem);
    localStorage.setItem("cart", tmpItems);
    dispatch({
        type: ADD_TO_CART,
        payload: tmpItems
    })
    return;
}


export const minusToCart = (item) => (dispatch, getState) => {
    const state = getState();
    let { items } = state.cart;
    items = items.map(cartItem => cartItem.item_id == item.item_id ? cartItem.qty-- && cartItem : cartItem);
    items = items.filter(item => item.qty !== 0);
    dispatch({
        type: MINUS_TO_CART,
        payload: items
    })
}


export const popPopToggle = (status) => ({
    type: CHANGEPOPSTATUS,
    payload: status
})

export const loadCart = () => async (dispatch, getState) => {
    const state = getState();
    const cart = state.cart.items;
    const token = state.user.token;
    const vouchercode = state.cart.voucherCode;
    const table = state.table.table;
    const res = await axios.post('cart/load', {
        merchant_id: state.restaurant.merchant_id,
        cart: JSON.stringify(cart),
        transaction_type: "dinein",
        client_token: token,
        voucher_code: vouchercode,
        table_number: table,
        main_order_id: state.cart.orderid,
    });

    if (res.data.code == 2) {
        dispatch({
            type: SETCARTERROR,
            payload: res.data.msg
        });

    } else {
        dispatch({
            type: SETCARTERROR,
            payload: ""
        });
    }

    dispatch({
        type: SETSERVERCART,
        payload: res.data.details
    })

    if (vouchercode && res.data.code == 1) {
        dispatch({ type: SETVOUCHERSUCCESS });
    }
}




export const placeOrder = () => async (dispatch, getState) => {
    const state = getState();
    const cart = state.cart.items;
    const token = state.user.token;
    const vouchercode = state.cart.isVoucherApplied ? state.cart.voucherCode : "";
    const table = state.table.table;

    const res = await axios.post('cart/order', {
        merchant_id: state.restaurant.merchant_id,
        cart: JSON.stringify(cart),
        transaction_type: "dinein",
        client_token: token,
        voucher_code: vouchercode,
        payment_list: state.cart.payment,
        hasMultipleOrder: true,
        mainOrderId: state.table.isContinueOrder ? state.cart.orderid : 0,
        order_instruction: state.cart.order_instruction,
        table_number: table,
        continue_ordering: state.table.isContinueOrder
    });

    if (res.data.code == 2) {
        dispatch({
            type: SETCARTERROR,
            payload: res.data.msg
        });
    } else if (res.data.code == 1) {
        localStorage.setItem("cart", JSON.stringify([]));
        dispatch({
            type: ORDERREDIRECT,
            payload: true
        });
        if (state.cart.orderid === 0 || !state.table.isContinueOrder) {
            localStorage.setItem("mainOrderId", res.data.details.order_id);
            dispatch({
                type: ORDERSUCESS,
                payload: res.data.details.order_id
            });
        }
        dispatch({
            type: ORDERREDIRECT,
            payload: false
        });
    } else if (res.data.code == 3) {
        localStorage.removeItem("mainOrderId");
        localStorage.setItem("cart", JSON.stringify([]));
        dispatch({
            type: ORDERREDIRECT,
            payload: true
        });
    }

}




export const closePopup = () => (dispatch, getState) => {
    dispatch({
        type: SET_MULTI_ORDER_POPUP_SHOWN,
        payload: true
    })
}


export const incCartQty = (key) => (dispatch, getState) => {
    const state = getState();
    let { items } = state.cart;
    items = items.map((cartItem, index) => {
        if (key == index) {
            cartItem = { ...cartItem };
            cartItem.qty++;
            cartItem.sub_item.forEach(subItem => {
                subItem.qty++;
            })
        }
        return cartItem;
    });

    dispatch({
        type: ADD_TO_CART,
        payload: items
    })
    dispatch(loadCart())
    throttle(() => dispatch(loadCart()), 1000);
}

export const decCartQty = (key) => (dispatch, getState) => {
    const state = getState();
    let { items } = state.cart;
    items = items.map((cartItem, index) => {
        if (key == index) {
            cartItem = { ...cartItem };
            cartItem.qty--;
            cartItem.sub_item.forEach(subItem => {
                subItem.qty--;
            })
        }
        return cartItem;
    });
    items = items.filter(item => item.qty !== 0);
    dispatch({
        type: MINUS_TO_CART,
        payload: items
    })
    dispatch(loadCart())
    throttle(() => dispatch(loadCart()), 1000);
}

export const setVoucherCode = (voucherCode) => (dispatch, getState) => {
    dispatch({
        type: SET_VOUCHER_CODE,
        payload: voucherCode
    })
}


export const setPaymentCode = (payment) => ({
    type: SETPAYMENT,
    payload: payment
})


export const getFinalCart = () => async (dispatch, getState) => {
    const state = getState();
    const orderId = state.cart.orderid;
    const res = await axios.post('order/multiplecart', {
        order_id: orderId,
    });

    if (res.data.code == 2) {
        dispatch({
            type: SETFINALCARTERROR,
            payload: res.data.msg
        });
    }

    if (res.data.code == 3) {
        localStorage.removeItem("mainOrderId");
        dispatch({
            type: REDIRECTORDER
        })
        dispatch({
            type: SETFINALCARTERROR,
            payload: res.data.msg
        })

        dispatch({
            type: FINALCARTRESPONSE,
            payload: { orders: [] }
        })
        localStorage.removeItem("table_number");
        dispatch({
            type: REMOVETABLE
        })
    }

    if (res.data.code == 1) {
        dispatch({
            type: FINALCARTRESPONSE,
            payload: res.data.details
        })
    }
}


export const finalSettle = () => async (dispatch, getState) => {
    const state = getState();
    const orderId = state.cart.orderid;
    const payment_list = state.cart.payment;
    const res = await axios.post('cart/settle', {
        order_id: orderId,
        payment_list: payment_list
    });

    if (res.data.code == 2) {
        dispatch({
            type: SETFINALCARTERROR,
            payload: res.data.msg
        });
    }

    if (res.data.code == 1) {
        if (res.data.details.next_step) {
            window.location.href =
                res.data.details.next_step +
                "&redirect=" + window.location.origin + "/verifypayment/" +
                res.data.details.order_id;

        } else {
            localStorage.removeItem("mainOrderId");
            dispatch({
                type: FINALSETTLE
            });

        }
    }
}


export const redirectSuccess = () => ({
    type: REDIRECTORDER
})

export const converDate = (utcSeconds) => {
    return moment.unix(utcSeconds).format('hh:mm A');

}

export const setOrderInstructions = (instruction) => (
    {
        type: SETORDERINSTRUCTIONS,
        payload: instruction
    }
)



